import { useEffect } from "react";
import { useAuth } from "react-oidc-context";
import { useNavigate } from "react-router-dom";
import { Spinner } from "../components/Spinner";
import { ErrorBanner } from "../components/ErrorBanner";

/**
 * OAuth redirect landing route. react-oidc-context processes the code/state
 * automatically; once authenticated we sync the router to "/".
 */
export function Callback() {
  const auth = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!auth.isLoading && auth.isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [auth.isLoading, auth.isAuthenticated, navigate]);

  if (auth.error) {
    return (
      <div className="centered-screen">
        <div className="auth-error-card">
          <ErrorBanner
            title="Could not complete sign-in"
            message={auth.error.message}
            onRetry={() => void auth.signinRedirect()}
            retryLabel="Try again"
          />
        </div>
      </div>
    );
  }

  return (
    <div className="centered-screen">
      <Spinner label="Signing you in…" />
    </div>
  );
}
